<section role="region" class="form-input">
  <header role="banner" class="form-input__header">
    <h3 role="heading" *ngIf="question.title" class="form-input__header__title" [innerHTML]="title"></h3>
    <p *ngIf="question.subtitle" class="form-input__header__subtitle" [innerHTML]="subtitle"></p>
  </header>

  <div class="form-input--mat-form-field">
    <mat-form-field [class.mat-form-field-has-prefix]="!!prefix">
      <mat-label>{{ label || 'Votre réponse' }}</mat-label>
      <input
        #input
        type="number"
        [id]="elm_id"
        [name]="elm_id"
        [formControl]="control"
        [placeholder]="placeholder"
        [required]="required"
        matInput
        autocomplete="no"
        (keyup.enter)="next(control)"
        min="0"
        oninput="validity.valid||(value='');"
      />

      <span *ngIf="prefix" matPrefix>{{ prefix }}</span>

      <mat-error *ngIf="control?.errors?.required"> {{ errorMsg || 'Veuillez saisir une valeur' }} </mat-error>
      <mat-error *ngIf="!!control.errors?.min"> La valeur saisie est trop basse </mat-error>
      <mat-error *ngIf="!!control.errors?.max"> La valeur saisie est trop élevée </mat-error>
    </mat-form-field>
  </div>

  <footer *ngIf="question.displayActions" class="form-input__actions">
    <button
      class="btn"
      type="button"
      (click)="next(control)"
      [attr.aria-label]="'Valider la question: ' + question.ariaLabel"
    >
      Valider
    </button>
    <button
      *ngIf="!required"
      class="btn-clean"
      type="button"
      (click)="skipQuestion.emit(control)"
      [attr.aria-label]="'Passer la question: ' + question.ariaLabel"
    >
      Passer
    </button>
  </footer>
</section>
